export const GET_RELATED_VIDEOS_LOADING = "GET_RELATED_VIDEOS_LOADING";
export const GET_RELATED_VIDEOS_SUCCESS = "GET_RELATED_VIDEOS_SUCCESS";
export const GET_RELATED_VIDEOS_ERROR = "GET_RELATED_VIDEOS_ERROR";
